<div class="modal-header py-2 bg-dark text-light">
  <h4 class="modal-title">
    배차정보 일괄삭제
  </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col">
                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                      운행시작일시
                    </label>
                    <div class="col-md-9 position-relative form-inline">
                        <input type="datetime-local" class="form-control form-control-sm w-auto"
                               formControlName="dtgRegDtFrom"
                               [ngClass]="{'is-invalid':submitted && (f.dtgRegDtFrom.errors || !checkRegDt)}">
                        <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtFrom.errors">
                            <div *ngIf="f.dtgRegDtFrom.errors.required">필수 입력 항목 입니다</div>
                        </div>
                        <div class="invalid-tooltip" *ngIf="submitted && !checkRegDt">
                            <div *ngIf="!checkRegDt">일정정보를 확인해주세요.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group row align-items-center">
                    <label class="col-md-3 mb-0">
                      운행종료일시
                    </label>
                    <div class="col-md-9 position-relative form-inline">
                        <input type="datetime-local" class="form-control form-control-sm w-auto"
                               formControlName="dtgRegDtTo"
                               [ngClass]="{'is-invalid':submitted && (f.dtgRegDtTo.errors || !checkRegDt)}">
                        <div class="invalid-tooltip" *ngIf="submitted && f.dtgRegDtTo.errors">
                            <div *ngIf="f.dtgRegDtTo.errors.required">필수 입력 항목 입니다</div>
                        </div>
                        <div class="invalid-tooltip" *ngIf="submitted && !checkRegDt">
                            <div *ngIf="!checkRegDt">일정정보를 확인해주세요.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
              차량
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm w-auto" placeholder="차량선택"
                           formControlName="dtgCarNo"
                           readonly>
                    <div class="input-group-append"
                         (click)="clickOpenModalCarList(DtgActionType.read)">
                        <button type="button" class="btn btn-outline-secondary">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                차량검색
                            </span>
                        </button>

                    </div>
                    <div class="input-group-append"
                         (click)="clickResetCar()">
                        <button type="button" class="btn btn-outline-secondary ml-1">
                            <i class="fas fa-times"></i>
                            <!--
                            <span class="ml-1">
                                초기화
                            </span>
                            -->
                        </button>
                    </div>
                    <div class="invalid-tooltip" *ngIf="(submitted && f.dtgUnitId.errors && f.dtgCarNo.errors)">
                        <div *ngIf="(f.dtgUnitId.errors && f.dtgCarNo.errors.required)">필수 입력 항목 입니다</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
              운전자
            </label>
            <div class="col-md-9 position-relative">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control form-control-sm w-auto" placeholder="운전자선택"
                           formControlName="userNm"
                           readonly>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="clickOpenModalUserList(DtgActionType.read)">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                운전자 검색
                            </span>
                        </button>
                    </div>
                    <div class="input-group-append"
                         (click)="clickResetDriver()">
                        <button type="button" class="btn btn-outline-secondary ml-1">
                            <i class="fas fa-times"></i>
                            <!--
                            <span class="ml-1">
                                  초기화
                            </span>
                            -->
                        </button>
                    </div>
                    <div class="invalid-tooltip" *ngIf="(submitted && f.userId.errors && f.userNm.errors)">
                        <div *ngIf="(f.userId.errors.required && f.userNm.errors.required)">필수 입력 항목 입니다</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                노선
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm w-auto"
                       formControlName="drivePathNm">
            </div>
            <div class="col-md-9 offset-md-3 small mt-1">
                <small class="form-text text-muted">
                    노선번호 및 노선명을 작성해 주세요.
                </small>
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                기점
            </label>
            <div class="col-md-9 position-relative">
              <input type="text" class="form-control form-control-sm w-auto"
                     formControlName="drivePathFromNm">
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label class="col-md-3 mb-0">
                종점
            </label>
            <div class="col-md-9 position-relative">
                <input type="text" class="form-control form-control-sm w-auto"
                       formControlName="drivePathToNm">
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
            (click)="clickDelete()"
            [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
              삭제
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
            (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
              취소
        </span>
    </button>
</div>
